import React, { useState } from "react";
import { Platform, Modal } from "react-native";
import DateTimePicker from "@react-native-community/datetimepicker";
import { Button, Text, View } from "./Themed";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import type { Moment } from "moment-mini";
import moment from "moment-mini";

type BETimePickerProps = {
  selected_time?:Moment,
  disabled?:boolean,
  onSelectTime: (time:Moment) => void
}
const BETimePicker = ({ selected_time, onSelectTime, disabled }:BETimePickerProps) => {
  const [date, setDate] = useState(selected_time ? selected_time : moment());
  const [show, setShow] = useState(false); // native iOS/Android


  const handleDone = () => {
    onSelectTime(date);
    setShow(false);
  }

  return (
    <View transparent>
        <Button transparent style={{ alignItems:'flex-end', padding:0 }} onPress={() => disabled ? alert('Edit not available') : setShow(!show)}>
          <Text theme='description'>{selected_time ? selected_time.format('MM/DD/YYYY hh:mm a') : 'No Time Selected'}</Text>
          <Text theme="action" style={{ marginTop:3 }}>Change</Text>
        </Button>
        <Modal
          transparent
          style={{ flex:1 }}
          visible={show}
        >
          <View type='blur' style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
            <View float>
              <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <View transparent style={{ flex:1 }}>
                  <Text theme='h1'>Selected Date / Time</Text>
                  <Text theme='description' style={{ marginTop:3 }}>Select a date and time below.</Text>
                </View>
              </View>
              <View style={{ padding:10 }}>
                {Platform.OS == 'web' ?
                  <DatePicker
                    selected={date.toDate()}
                    onChange={(date) => setDate(moment(date as Date))}
                    showTimeSelect
                    timeIntervals={1}
                    dateFormat="Pp"
                    inline // makes it always visible
                  />
                  :
                  <DateTimePicker
                    value={date.toDate()}
                    display="spinner"
                    mode='datetime'
                    onChange={(_, date) => setDate(moment(date))}
                  />
                  }
              </View>
              <View type='footer' style={{ padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                  <Button
                    title="DONE"
                    type="success"
                    onPress={() => handleDone()}
                  />
              </View>
            </View>
          </View>
        </Modal>
    </View>
  );
}

export default BETimePicker
